import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateCart } from 'api/cart/_requests';
import Button from 'components/base/Button';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import { updateCart as updateCartAction } from 'redux-state/user/cartSlice';

interface QuantityButtonsProps {
  type?: 'default' | 'secondary';
  quantity: number;
  setQuantity: Dispatch<SetStateAction<number>>;
  productId: string;
  vendorId: string;
  formCart?: boolean;
  variantId: string;
}

const QuantityButtons = ({
  type = 'default',
  quantity,
  setQuantity,
  productId,
  vendorId,
  formCart = true,
  variantId
}: QuantityButtonsProps) => {
  const dispatch = useDispatch();
  const handleIncrease = () => {
    setQuantity(quantity + 1);
    handleQuantityChange(quantity + 1);
  };

  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
      handleQuantityChange(quantity - 1);
    }
  };

  const handleQuantityChange = async (qty: number) => {
    if (!formCart) {
      return;
    }
    const data = {
      vendorId: vendorId,
      productId: productId,
      variantId: variantId,
      quantity: qty
    };
    await updateCart(data).then(res => {
      dispatch(
        updateCartAction({
          vendorId: vendorId,
          productId: productId,
          variantId: variantId,
          quantity: qty
        })
      );
    });
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuantity(Number(e.target.value));
    handleQuantityChange(Number(e.target.value));
  };

  if (type === 'default') {
    return (
      <div className="d-flex flex-between-center">
        <Button
          variant="phoenix-primary"
          className="px-3"
          onClick={handleDecrease}
        >
          <FontAwesomeIcon icon={faMinus} />
        </Button>
        <input
          type="number"
          className="form-control text-center input-spin-none bg-transparent border-0 outline-none"
          style={{ width: 50 }}
          min="1"
          value={quantity}
          onChange={handleChange}
        />
        <Button
          variant="phoenix-primary"
          className="px-3"
          onClick={handleIncrease}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </div>
    );
  }
  return (
    <div className="input-group input-group-sm flex-nowrap">
      <Button size="sm" className="px-2" onClick={handleDecrease}>
        -
      </Button>
      <input
        className="form-control text-center input-spin-none bg-transparent border-0 px-0"
        type="number"
        min={1}
        value={quantity}
        onChange={handleChange}
      />
      <Button size="sm" className="px-2" onClick={handleIncrease}>
        +
      </Button>
    </div>
  );
};

export default QuantityButtons;
